<script setup lang="ts">
import { useSessionStore } from '@/core/stores/session.store'
import { useAuthStore } from '@/core/stores/auth.store'
import { useRouter } from 'vue-router'
import { Button } from '@toteat-eng/design-system-vue'
import AppModal from '@/shared/components/ui/AppModal.vue'

const sessionStore = useSessionStore()
const authStore = useAuthStore()
const router = useRouter()

async function handleLogout() {
  sessionStore.hideExpiredModal()
  await authStore.logout()
  router.push('/login')
}
</script>

<template>
  <AppModal
    :show="sessionStore.showSessionExpiredModal"
    variant="warning"
    title="Sesión Expirada"
    description="Por seguridad, tu sesión ha caducado. Por favor, inicia sesión nuevamente para continuar."
    width="420px"
    :closable="false"
    :mask-closable="false"
  >
    <template #footer>
      <Button variant="primary" text="Iniciar Sesión" @click="handleLogout" />
    </template>
  </AppModal>
</template>
